import React from 'react';
import WorkspaceGuideDialog from '../../../shared/ui/common/WorkspaceGuideDialog';
import { buildMappingWorkspaceGuideContent } from '../lib/mappingWorkspaceGuideContent';

interface MappingWorkspaceGuideDialogProps {
  open: boolean;
  onClose: () => void;
  onStartTour: () => void;
  selectedProfileName: string;
  scopeCount: number;
  totalMappings: number;
  mappedMappings: number;
  requiredOpen: number;
  workspaceReady: boolean;
}

const MappingWorkspaceGuideDialog: React.FC<MappingWorkspaceGuideDialogProps> = ({
  open,
  onClose,
  onStartTour,
  selectedProfileName,
  scopeCount,
  totalMappings,
  mappedMappings,
  requiredOpen,
  workspaceReady,
}) => (
  <WorkspaceGuideDialog
    open={open}
    onClose={onClose}
    dialogTitle="Mapping guide"
    onAction={onStartTour}
    {...buildMappingWorkspaceGuideContent({
      selectedProfileName,
      scopeCount,
      totalMappings,
      mappedMappings,
      requiredOpen,
      workspaceReady,
    })}
  />
);

export default MappingWorkspaceGuideDialog;
